import { render } from "./master.vue?vue&type=template&id=22d1f0f9"
import script from "./master.vue?vue&type=script&lang=js"
export * from "./master.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__